import Home from './Home';
import './Home.scss';

export default Home;